module.exports = __webpack_public_path__ + "assets/icon_arrows.d44d6210.svg";